module.exports = __webpack_public_path__ + "img/nav-design-diamondrings@2x.dbb7b5f.jpg";